export enum HeadersType {
  updateEmail = 'Update email address',
  bank = 'Bank',
  accountType = 'Account type',
  relationshipType = 'Relationship type',
}
